import React from 'react'
import Header from '../Header/Header'
import PagosData from '../../Components/Admin/PagosData/PagosData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function Pagos() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <PagosData />

                </div>
            </section>
        </div>
    )
}
